import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default {
  methods: {
    exportPDF (selector = 'body', filename = 'filename') {
      // window.html2canvas = html2canvas // Vue.js 특성상 window 객체에 직접 할당해야한다.
      const that = this
      // let pdf = new JsPDF('p', 'mm', 'a4')
      // let canvas = pdf.canvas
      const pageWidth = 210 // 캔버스 너비 mm
      const pageHeight = 295 // 캔버스 높이 mm
      // canvas.width = pageWidth
      const elem = document.querySelector(selector)
      const width = elem.offsetWidth // 셀렉트한 요소의 px 너비
      const height = elem.offsetHeight // 셀렉트한 요소의 px 높이
      const imgHeight = pageWidth * height / width // 이미지 높이값 px to mm 변환
      if (!elem) {
        console.warn(selector + ' is not exist.')
        return false
      }
      // console.log(elem)
      html2canvas(elem, {scale: 2, logging: false})
        .then(canvas => {
          const pdf = new JsPDF()
          pdf.setFillColor('#e7ebf1')
          pdf.rect(0, 0, 210, 300, 'F')
          let position = 0
          const imgData = canvas.toDataURL('image/png')
          pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight, undefined, 'slow') // Paging 처리
          let heightLeft = imgHeight // 페이징 처리를 위해 남은 페이지 높이 세팅.
          heightLeft -= pageHeight
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight
            pdf.addPage()
            pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight)
            heightLeft -= pageHeight
          }
          pdf.save(filename + '.pdf')
          that.pdfLoading = false
        })
        .catch((err) => {
          that.pdfLoading = false
          this.$message.error('PDF 다운로드 실패')
          console.error('html2canvas error : ', err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/pdf.js